"use strict";
import React from "react";
import { assertType } from "./data/types/type_utilities";
export default React.createClass(
  assertType({
    render: function() {
      var child;
      if (this.props.modalView) {
        var children;
        child = React.Children.only(this.props.children);
        if (React.Children.count(child.props.children) === 0) {
          children = [];
        } else if (React.Children.count(child.props.children) === 1) {
          children = [child.props.children];
        } else {
          children = [...child.props.children];
        }
        children.push(this.backdrop(child));
        children.push(this.view(child, this.props.modalView));
        child = React.cloneElement(child, {}, children);
      } else {
        child = this.props.children;
      }
      return child;
    },
    backdrop: function(parent) {
      return React.createElement(this.elementType(parent), {
        key: "blocker-backdrop",
        className: "cg-busy cg-busy-backdrop cg-busy-backdrop-animation"
      });
    },
    view: function(parent, modalView) {
      return React.createElement(
        this.elementType(parent),
        {
          key: "blocker-view",
          className: "cg-busy cg-busy-animation"
        },
        React.createElement(
          this.elementType(this.elementType(parent)),
          {
            className: "cg-busy-default-wrapper",
            style: {
              position: "absolute",
              top: "0px",
              left: "0px",
              right: "0px",
              bottom: "0px"
            }
          },
          React.createElement(
            this.elementType(this.elementType(this.elementType(parent))),
            {
              className: "cg-busy-default-container"
            },
            modalView
          )
        )
      );
    },
    elementType: function(parent) {
      var type = parent.type || parent;
      if (type === "table") {
        return "tbody";
      } else if (type === "tbody") {
        return "tr";
      } else if (type === "tr") {
        return "td";
      } else {
        return "div";
      }
    }
  })
);
